export enum ModalName {
  Auth = 'auth',
  BuyPacks = 'buyPacks',
  BoxDropRates = 'boxDropRates',
  OpenMysteryBox = 'openMysteryBox',
  BoxSaleOver = 'boxSaleOver',
}
